import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { createBrowserHistory } from 'history'
import { combineReducers } from 'redux'

import { reducerRegistry } from './reducer-registry'
import { rootApi } from './root-api'
import { rootApi as rootApiGraphql } from './root-api-graphql'

export default (reducer, preloadedState = {}, history = createBrowserHistory()) => {
  const withPreservedPreloadedState = (reducers) => {
    Object.keys(preloadedState).forEach((reducerKey) => {
      if (!reducers[reducerKey]) {
        reducers[reducerKey] = (state = null) => state
      }
    })

    return {
      ...reducers,
      [rootApi.reducerPath]: rootApi.reducer,
      [rootApiGraphql.reducerPath]: rootApiGraphql.reducer
    }
  }

  const isLegacyReducer = reducer && typeof reducer === 'object' && Object.keys(reducer).length > 0

  const store = configureStore({
    reducer: {
      ...(isLegacyReducer ? reducer : withPreservedPreloadedState(reducerRegistry.list())),
      [rootApi.reducerPath]: rootApi.reducer,
      [rootApiGraphql.reducerPath]: rootApiGraphql.reducer
    },
    preloadedState,
    middleware: (getDefaultMiddleware) => (
      getDefaultMiddleware({
        thunk: {
          extraArgument: { history }
        },
        serializableCheck: false,
        immutableCheck: {
          warnAfter: 1000
        }
      }).concat(rootApi.middleware)
        .concat(rootApiGraphql.middleware)
    ),
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers({ autoBatch: { type: 'tick' } })
  })

  if (!isLegacyReducer) {
    reducerRegistry.onChange((reducers) => {
      store.replaceReducer(combineReducers(withPreservedPreloadedState(reducers)))
    })
  }

  setupListeners(store.dispatch)

  return store
}
